import React, { useState, useEffect } from 'react';
import {
  FilterContext,
  useApplyFilters,
  formatCount,
  useServicesContext,
  handleChangeAllCarlineModels,
} from '@oneaudi/vtp-shared';
import { StyledCheckbox, StyledCheckboxWrapper } from '../styles/QuickModelCheckbox.styles';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';

export interface QuickModelCheckboxProps {
  groupHeadline: string;
  itemText: string;
  carlinesGroupMembers: [];
  carlineGroup: string;
  filterCategory: string;
}

export const QuickModelCheckbox: React.FC<QuickModelCheckboxProps> = ({
  groupHeadline,
  itemText,
  carlinesGroupMembers,
  carlineGroup,
  filterCategory,
}) => {
  const applyFilters = useApplyFilters();
  const context = React.useContext(FilterContext);

  const { getAdditionalService } = useServicesContext();
  const localeService = getAdditionalService('gfa:locale-service') as LocaleServiceV1;
  const locale = `${localeService.language}-${localeService.countryCode}`;

  const [count, setCount] = useState<number>(0);
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const isDisabled = count <= 0;

  const handleChange = () => {
    // Optimistic update: immediately update local state
    setIsChecked(!isChecked);

    return handleChangeAllCarlineModels(
      applyFilters,
      context?.filterData!,
      carlinesGroupMembers,
      isChecked,
      setIsChecked,
      carlineGroup,
      itemText,
      filterCategory,
      true
    );
  };

  useEffect(() => {
    const checkboxFiltersData = context?.filterData?.groups;
    let countAll = 0;
    carlinesGroupMembers.forEach((member: any) => {
      countAll += checkboxFiltersData[groupHeadline].members[member].count;
    });
    setCount(countAll);

    const members = context?.filterData?.groups?.carline?.members ?? {};
    const allAvailableCarlineGroupMembersAreSelected = carlinesGroupMembers.some(
      (carline) => members[carline]?.active === true
    );
    setIsChecked(allAvailableCarlineGroupMembersAreSelected);
  }, [context?.filterData?.groups]);

  return (
    <StyledCheckboxWrapper>
      <StyledCheckbox
        hideLabelOptional
        inputId={`checkbox${itemText}`}
        checked={isChecked}
        disabled={isDisabled}
        onChange={handleChange}
        label={`${itemText} (${formatCount(count, locale).toString()})`}
      />
    </StyledCheckboxWrapper>
  );
};

export default QuickModelCheckbox;
